import type { SVGProps } from "react";
import * as React from "react";

const SvgBox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m21 16 1 .001V16zm0-8h1v-.001zm-1-1.73.5-.866-.004-.002zm-7-4-.5.866.004.002zm-2 0 .496.868.004-.002zm-7 4-.496-.868-.004.002zM3 8l-1-.001V8zm0 8H2v.001zm1 1.73-.5.866.004.002zm7 4 .5-.866-.004-.002zm2 0-.496-.868-.004.002zm7-4 .496.868.004-.002zM3.77 6.094a1 1 0 1 0-1 1.732zM12 12.01l-.5.866a1 1 0 0 0 1 0zm9.23-4.184a1 1 0 0 0-1-1.732zM11 22.08a1 1 0 1 0 2 0zM13 12a1 1 0 1 0-2 0zm9 4V8h-2v8zm0-8.001a3 3 0 0 0-.403-1.498l-1.731 1a1 1 0 0 1 .134.5zm-.403-1.498A3 3 0 0 0 20.5 5.404l-1 1.732a1 1 0 0 1 .366.366zm-1.1-1.1-7-4-.993 1.737 7 4zM13.5 1.405a3 3 0 0 0-1.5-.402v2a1 1 0 0 1 .5.134zM12 1.002a3 3 0 0 0-1.5.402l1 1.732a1 1 0 0 1 .5-.134zm-1.496.4-7 4 .992 1.736 7-4zM3.5 5.404a3 3 0 0 0-1.097 1.097l1.731 1a1 1 0 0 1 .366-.365zM2.403 6.501A3 3 0 0 0 2 7.999l2 .002a1 1 0 0 1 .134-.5zM2 8v8h2V8zm0 8.001a3 3 0 0 0 .403 1.498l1.731-1a1 1 0 0 1-.134-.5zm.403 1.498A3 3 0 0 0 3.5 18.596l1-1.732a1 1 0 0 1-.366-.366zm1.1 1.1 7 4 .993-1.737-7-4zm6.997 3.997a3 3 0 0 0 1.5.402v-2a1 1 0 0 1-.5-.134zm1.5.402a3 3 0 0 0 1.5-.402l-1-1.732a1 1 0 0 1-.5.134zm1.496-.4 7-4-.992-1.736-7 4zm7.004-4.002a3 3 0 0 0 1.097-1.097l-1.731-1a1 1 0 0 1-.366.365zm1.097-1.097A3 3 0 0 0 22 16.001L20 16a1 1 0 0 1-.134.5zM2.77 7.826l8.73 5.05 1.002-1.732-8.73-5.05zm9.732 5.05 8.73-5.05-1.002-1.732-8.73 5.05zM13 22.08V12h-2v10.08z"
    />
  </svg>
);
export default SvgBox;
